<input #inputPicture class="display-none" type="file" (change)="setInstanceFileStorage($event)" [disabled]="isDisable">
<mat-form-field appearance="standard" (click)="openFile()">
  <mat-label>{{title}}<span class="asterisk" *ngIf="utils.isRequiredField(inputFormCtrl)">*</span></mat-label>
  <input matInput type="text" class="field__form--input" [formControl]="inputFormCtrl" [disabled]="isDisable" readonly>
  <i class="fas fa-paperclip field__form--icon" for="upload-photo"></i>
</mat-form-field>
<span class="pattern pattern--invalid" *ngIf="inputFormCtrl.errors && inputFormCtrl.errors.required">
  Campo requerido
</span>